var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDefaultProfile = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    cx: 17.5,
    cy: 18,
    r: 17,
    fill: "#06061b",
    stroke: "#9999ac"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.01 12.569c0-.317.258-.569.57-.569h.01c.187 0 .356.088.466.235l2.187 2.915a.88.88 0 0 0 .7.35h2.625a.88.88 0 0 0 .7-.35l2.188-2.915A.582.582 0 0 1 21.92 12h.011c.317 0 .569.257.569.569V19a5.251 5.251 0 0 1-5.25 5.25A5.251 5.251 0 0 1 12 19v-6.431h.01Zm3.063 7.306a.875.875 0 1 0 0-1.75.875.875 0 0 0 0 1.75Zm5.25-.875a.875.875 0 1 0-1.75 0 .875.875 0 0 0 1.75 0Z",
    fill: "#9999ac"
  })));
};
export default SvgDefaultProfile;